var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasTip)?_c('h3',{staticClass:"text-body-1"},[_vm._v("Tip : "+_vm._s(_vm.formatUSD(_vm.getTipFromCart)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }